export default function boxImageUrlFormatter(imageName) {
  if (!imageName) return undefined

  if (
    typeof imageName === 'string' &&
    (imageName.startsWith('http://') ||
      imageName.startsWith('https://') ||
      imageName.startsWith('data:'))
  ) {
    return imageName
  }
  return `https://s3.${process.env.RAZZLE_S3_REGION}.amazonaws.com/${process.env.RAZZLE_S3_BUCKET}/logo/${imageName}`
}
